import { AfterViewInit, Component, inject } from '@angular/core';
import { BankidSigningModalComponent } from '@app/bankid-signing-modal/bankid-signing-modal.component';
import { LoginService } from '@app/shared/services/login.service';
import { BankIdAuthenticateResultModel } from '@shared/service-proxies/service-proxies';

@Component({
  selector: 'nw-messaging',
  templateUrl: './messaging.component.html',
  styleUrl: './messaging.component.scss'
})
export class MessagingComponent implements AfterViewInit {

  private loginService = inject(LoginService);

  ngAfterViewInit() {
    document.dispatchEvent(new Event('DOMContentLoaded'));
  }

  loginWithBankId(bankidSigningModal: BankidSigningModalComponent) {
    bankidSigningModal.show();
  }

  bankIdSignIn(data: BankIdAuthenticateResultModel) {
    this.loginService.processBankIdLoginResult(data);
  }

}
